import React from 'react'
import {HashRouter as Router, Route, Switch } from 'react-router-dom'

import NotFound from './NotFound'
import TopNav from './TopNav'
import SecondaryNav from './SecondaryNav'
import Footer from './Footer'
import Home from './Home'
import Courses from './Courses'
import Requirements from './Requirements'
import Search from '../components/Search'
import SubNav from './SubNav'
import CoursePopup from './CoursePopup'
import Links from './Links'
import MobileNav from '../components/MobileNav'


class PageContainer extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      view: 'grid',
      navigation: 'noNav',
      secondaryNavType: 'categories',  // categories, links
      mobile: false,
      winWidth: this.props.winDimensions[0],
      winHeight: this.props.winDimensions[1],
      category: '',
      showSubNav: false,
      coursePopupID: undefined,
      supportedBrowser: this.props.browserInfo[0],
      mobileNav: false,
      themeStyles: this.props.themeStyles,
      themeStyleBackground: this.props.themeStyles.background
    }

  }

  viewChange = (a) => {
    if ( a !== undefined) {
      this.setState({
        view: a
      })
    }
  }

  navChange = (a) => {
    const AppContainer = document.getElementById('appContainer')
    AppContainer.scrollTop = 0;
    if ( a == 'hideNav' ) {
      this.setState({ navigation: 'noNav' })
    } else {
      if ( this.state.navigation == 'noNav' ) {
        this.setState({
          navigation: 'activeNav'
        })
      } else if ( this.state.navigation == 'activeNav' ) {
        this.setState({
          navigation: 'noNav'
        })
      }
    }
  }

  navTypeChange = (a) => {
    this.setState({
      secondaryNavType: a
    })
  }

  toggleMobileNav = () => {
    this.setState({
      mobileNav: !this.state.mobileNav
    })
  }

  setCategory = (a) => { this.setState({ category: a }) }

  showSubNav = (a) => { this.setState({ showSubNav: a }) }

  showCoursePopup = (a) => { this.setState({ coursePopupID: a}) }


  render () {

    const Featured = this.props.jsonData.filter(course => course.featured == "Featured")

    let mobileClass

    if ( this.props.mobileView === false ) {
      mobileClass = ''
    } else {
      mobileClass = 'mobile'
    }

    const ContentBackgroundStyle = {
      backgroundColor: this.props.themeStyles.background
    }

    let homeSwitch = false;

    if ( this.props.mobileView === true ) {
      homeSwitch = true
    }

    if ( Featured.length === 0 ) {
      homeSwitch = true
    }

    return (
      <Router>
       <div id="appContainer">
         {this.props.mobileView === false &&
           <Links
             themeLinks={this.props.themeLinks}
             localURL={this.props.localURL}
             companyID={this.props.companyID}
             themeStyles={this.props.themeStyles}
            />
         }
         <TopNav
           navChange={this.navChange}
           loggedIn={this.props.loggedIn}
           localURL={this.props.localURL}
           mobile={this.props.mobileView}
           navChange={this.navChange}
           navTypeChange={this.navTypeChange}
           toggleMobileNav={this.toggleMobileNav}
           themeStyles={this.props.themeStyles}
           homeButton={Featured}
         />
         {this.props.mobileView === true &&
           <MobileNav
             loggedIn={this.props.loggedIn}
             localURL={this.props.localURL}
             showState={this.state.mobileNav}
             toggleMobileNav={this.toggleMobileNav}
             navChange={this.navChange}
             navTypeChange={this.navTypeChange}
             themeLinks={this.props.themeLinks}
             themeStyles={this.props.themeStyles}
           />
         }
         {this.state.showSubNav === true &&
           <SubNav
             category={this.state.category}
             test={Router.match}
             viewState={this.state.view}
             mobile={this.props.mobileView}
             navTypeChange={this.navTypeChange}
             viewChange={this.viewChange}
             navChange={this.navChange}
             show={this.state.showSubNav}
             themeStyles={this.props.themeStyles}
           />
         }
         {this.state.coursePopupID !== undefined &&
           <CoursePopup
             jsonData={this.props.jsonData}
             localURL={this.props.localURL}
             courseID={this.state.coursePopupID}
             category={this.state.category}
             mobile={this.props.mobileView}
             supported={this.state.supportedBrowser}
             themeStyles={this.props.themeStyles}
             loggedInInfo={this.props.loggedInInfo}
           />
         }
         <div id="contentContainer" style={ContentBackgroundStyle} ref="appContainer" className={mobileClass + ' ' + this.state.navigation + ' ' + this.state.secondaryNavType}>
            <section id="contentArea">
            <Switch>
              {homeSwitch === false &&
                <Route exact path="/" render={(props) => (<Home {...props} jsonData={this.props.jsonData} localURL={this.props.localURL} mobile={this.props.mobileView} navChange={this.navChange} navTypeChange={this.navTypeChange} supported={this.state.supportedBrowser} themeStyles={this.props.themeStyles} />)} />
              }
              {homeSwitch === true &&
                <Route exact path="/" render={(props) => (<Courses {...props} jsonData={this.props.jsonData} localURL={this.props.localURL} viewState={this.state.view} showSubNav={this.showSubNav} setCategory={this.setCategory} category={this.state.category} showCoursePopup={this.showCoursePopup} courseID={this.state.coursePopupID} supported={this.state.supportedBrowser} mobile={this.props.mobileView} themeStyles={this.props.themeStyles} />)} />
              }
              <Route exact path="/courses" render={(props) => (<Courses {...props} jsonData={this.props.jsonData} localURL={this.props.localURL} viewState={this.state.view} showSubNav={this.showSubNav} setCategory={this.setCategory} category={this.state.category} showCoursePopup={this.showCoursePopup} courseID={this.state.coursePopupID} supported={this.state.supportedBrowser} mobile={this.props.mobileView} themeStyles={this.props.themeStyles} loggedInInfo={this.props.loggedInInfo} />)} />
              <Route exact path="/courses/:category" render={(props) => (<Courses {...props} jsonData={this.props.jsonData} localURL={this.props.localURL} viewState={this.state.view} showSubNav={this.showSubNav} setCategory={this.setCategory} category={this.state.category} showCoursePopup={this.showCoursePopup} courseID={this.state.coursePopupID} supported={this.state.supportedBrowser} mobile={this.props.mobileView} themeStyles={this.props.themeStyles} loggedInInfo={this.props.loggedInInfo} />)} />
              <Route path="/courses/:category/:id" render={(props) => (<Courses {...props} jsonData={this.props.jsonData} localURL={this.props.localURL} viewState={this.state.view} showSubNav={this.showSubNav} setCategory={this.setCategory} category={this.state.category} showCoursePopup={this.showCoursePopup} courseID={this.state.coursePopupID} supported={this.state.supportedBrowser} mobile={this.props.mobileView} themeStyles={this.props.themeStyles} loggedInInfo={this.props.loggedInInfo} />)} />
              <Route exact path="/requirements" render={(props) => (<Requirements {...props} browserInfo={this.props.browserInfo} themeStyles={this.props.themeStyles} />)} />
              <Route path="/requirements/:os" render={(props) => (<Requirements {...props} browserInfo={this.props.browserInfo} themeStyles={this.props.themeStyles} />)} />
              <Route path="/search" render={(props) => (<Search {...props} jsonData={this.props.jsonData} localURL={this.props.localURL} themeStyles={this.props.themeStyles} />)} />
              <Route component={NotFound} themeStyles={this.props.themeStyles} />
            </Switch>
          </section>
          <Footer themeStyles={this.props.themeStyles} />
        </div>
        <SecondaryNav navType="categories" secondaryNavType={this.state.secondaryNavType} mobile={this.props.mobileView} activeState={this.state.navigation} navChange={this.navChange} categories={this.props.categories} themeLinks={this.props.themeLinks} localURL={this.props.localURL} showSubNav={this.state.showSubNav} themeStyles={this.props.themeStyles} />
      </div>
      </Router>
    )
  }

}

export default PageContainer
